<template>
    <div id="home1">

        <hero-section></hero-section>

        <endorse></endorse>

        <demands></demands>

        <demands2></demands2>

        <protest-info></protest-info>

        <share-section></share-section>

        <endorsements></endorsements>

        <contact></contact>

        <social></social>

        <footer-section></footer-section>

    </div>
    
</template>

<script>
    "use strict";
    import HeroSection from './Sections/HeroSection.vue'
    import Demands from "./Sections/Demands";
    import Demands2 from "./Sections/Demands2";
    import Endorse from "./Sections/Endorse";

    export default {
        name: 'Home',
        components: {
          Endorse,
          Demands,
          Demands2,
          HeroSection
        },
    }

</script>
